import classNames from 'classnames';
import React from 'react';
import StatusLabelTheme from 'store/configs/StatusLabelTheme';
import Chip from '@mui/material/Chip';
import ComponentProps from 'store/types/ComponentProps';

import styles from './StatusLabel.module.scss';

interface StatusLabelClasses {
  label?: string;
}

interface StatusLabelProps extends ComponentProps {
  theme?: StatusLabelTheme;
  variant?: 'filled' | 'outlined';
  status: string;
  fullWidth?: boolean;
  classes?: StatusLabelClasses;
}

const StatusLabel: React.FunctionComponent<StatusLabelProps> = ({
  variant = 'filled',
  theme = 'primary-theme',
  status,
  className,
  fullWidth,
  classes,
}) => (
  <Chip
    variant={variant}
    label={status}
    className={classNames(styles.label, styles[theme], className, {
      [styles.filled]: variant === 'filled',
      [styles.outlined]: variant === 'outlined',
      [styles.fullWidth]: fullWidth,
    })}
    classes={{ label: classes?.label }}
    data-testid={'status-label'}
  />
);

export default StatusLabel;
